import * as types from './types'
import storage from '@/Plugins/storage'

export default () => ({
  default: {
    id: null,
    uid: null,
    orgCode: '',
    orgName: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipcode: '',
    storeDaysOpen: '',
    storeDaysClose: '',
    storeHoursOpen: '',
    storeHoursClose: '',
    nutritionVisibility: 0,
    livestreamVisibility: 0,
    isActive: 1,
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    coachingVisibility: 0,
    coachingScheduleUrl: '',
    coachwallVisibility: 0,
    challengesVisibility: 0,
    bodyCompositionVisibility: 0,
    phone: '',
    showChallenges: false,
    logourl: '',
    deeplinkShort: '',
    EmailLiveMessage: null,
    EmailRecapMessage: null,
    EmailWelcomeMessage: null,
    weburl: '',
    assessmentVisibility: 0,
    progressPhotosVisibility: 0,
    dashboardVisibility: 0,
    isWelcomeMessage: true,
    isBatchIntel: false,
  },
  examineOrganization: storage.session.getItem(types.STORE_EXAMINE_ORG)
    ? JSON.parse(storage.session.getItem(types.STORE_EXAMINE_ORG))
    : null,
  organization: null,
  organizations: [],
  found: [],
  pager: storage.session.getItem(types.STORE_PAGER)
    ? JSON.parse(storage.session.getItem(types.STORE_PAGER))
    : {
        pageSize: 10,
        orderBy: 'asc',
        sortBy: null,
        search: null,
        total: 0,
        page: 1,
        pages: 1,
      },
  isChecked: false,
  members: [],
  foundMembers: [],
  tags: [],
})
